import { render, staticRenderFns } from "./HappeningItem.vue?vue&type=template&id=6c89b612&scoped=true"
import script from "./HappeningItem.vue?vue&type=script&lang=js"
export * from "./HappeningItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c89b612",
  null
  
)

export default component.exports